import { BulkSignOrchestratorApiTypes } from "@rshbintech.dboul/http";

export const isErrorInfo = (
  error: unknown
): error is BulkSignOrchestratorApiTypes.ErrorInfo =>
  !!error && typeof error === "object" && "message" in error;
